import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "report" }
const _hoisted_2 = { class: "tbdc-report-header" }
const _hoisted_3 = {
  key: 0,
  style: {"float":"right"},
  class: "tbdc-report-header-block"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  style: {"float":"right"},
  class: "tbdc-report-header-block"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "text-left tbdc-impact-col1" }
const _hoisted_12 = { class: "text-right tbdc-impact-col2" }
const _hoisted_13 = { class: "text-right tbdc-impact-col3" }
const _hoisted_14 = { class: "text-right tbdc-impact-col4" }
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = { class: "text-right" }
const _hoisted_17 = { class: "text-right" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "text-left tbdc-impact-col1" }
const _hoisted_20 = { class: "text-right tbdc-impact-col2" }
const _hoisted_21 = { class: "text-right tbdc-impact-col3" }
const _hoisted_22 = { class: "text-right tbdc-impact-col4" }
const _hoisted_23 = { class: "text-right" }
const _hoisted_24 = { class: "text-right" }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { class: "text-left tbdc-impact-col1" }
const _hoisted_27 = { class: "text-right tbdc-impact-col2" }
const _hoisted_28 = { class: "text-right tbdc-impact-col3" }
const _hoisted_29 = { class: "text-right tbdc-impact-col4" }
const _hoisted_30 = { class: "text-right" }
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = { style: {"pointer-events":"none","margin-top":"0.5em"} }
const _hoisted_33 = { class: "font-weight-thin" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "text-right" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { class: "text-left tbdc-impact-col1" }
const _hoisted_40 = { class: "text-right tbdc-impact-col2" }
const _hoisted_41 = { class: "text-right tbdc-impact-col3" }
const _hoisted_42 = { class: "text-right tbdc-impact-col4" }
const _hoisted_43 = { class: "text-right" }
const _hoisted_44 = { class: "text-right" }
const _hoisted_45 = { class: "text-right" }
const _hoisted_46 = { class: "text-left tbdc-impact-col1" }
const _hoisted_47 = { class: "text-right tbdc-impact-col2" }
const _hoisted_48 = { class: "text-right tbdc-impact-col3" }
const _hoisted_49 = { class: "text-right tbdc-impact-col4" }
const _hoisted_50 = { class: "text-right" }
const _hoisted_51 = { class: "text-right" }
const _hoisted_52 = { class: "text-left tbdc-impact-col1" }
const _hoisted_53 = { class: "text-right tbdc-impact-col2" }
const _hoisted_54 = { class: "text-right tbdc-impact-col3" }
const _hoisted_55 = { class: "text-right tbdc-impact-col4" }
const _hoisted_56 = { class: "text-right" }
const _hoisted_57 = { class: "text-right" }
const _hoisted_58 = { class: "font-weight-thin" }
const _hoisted_59 = { class: "font-weight-thin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_ModelPropertyValue = _resolveComponent("ModelPropertyValue")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_Mapbox = _resolveComponent("Mapbox")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.localShow,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localShow) = $event)),
    width: "21cm"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.scenario && _ctx.model)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              id: "scenarioReport"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { "primary-title": "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.$tc("message.scenarioReport")), 1),
                      (_ctx.model.hasMainLogo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_ctx.model != null)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: '/api/models/' + _ctx.model.id + '/main-logo',
                                  class: "tbdc-report-header-image"
                                }, null, 8, _hoisted_4))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.model.hasSecondaryLogo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_ctx.model != null)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: '/api/models/' + _ctx.model.id + '/secondary-logo',
                                  class: "tbdc-report-header-image"
                                }, null, 8, _hoisted_6))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    (!_ctx.scenarioDifferences)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_7, _toDisplayString(_ctx.$tc("message.busyLoading")), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.model.scenarioReportFormat  && _ctx.scenarioDifferences)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.scenario)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                                _createElementVNode("h3", null, _toDisplayString(_ctx.scenario.name), 1),
                                _createElementVNode("p", _hoisted_9, "Gegenereerd op " + _toDisplayString(_ctx.$filters.datetime(new Date(), _ctx.$i18n.locale)) + " door " + _toDisplayString(_ctx.account.name), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("section", null, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$tc("message.locationsType" + _ctx.model.locationsType + "Impact")), 1),
                            (_ctx.scenarioDifferences.impactOutputLocationPropertyTitle)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  innerHTML: _ctx.removeMdiBracketToIcon(_ctx.scenarioDifferences.impactOutputLocationPropertyTitle)
                                }, null, 8, _hoisted_10))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_table, { density: "compact" }, {
                              default: _withCtx(() => [
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$tc("message.locationsType" + _ctx.model.locationsType + "Name")), 1),
                                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$tc("message.before")), 1),
                                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$tc("message.after")), 1),
                                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$tc("message.difference")), 1)
                                  ])
                                ]),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarioDifferences.locations.slice(0,25), (scenarioDifference) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: scenarioDifference.locationID
                                    }, [
                                      _createElementVNode("td", null, _toDisplayString(scenarioDifference.locationName), 1),
                                      _createElementVNode("td", _hoisted_15, [
                                        _createVNode(_component_ModelPropertyValue, {
                                          numberValue: (scenarioDifference.outputDefault == null ? 0 : scenarioDifference.outputDefault),
                                          model: _ctx.model
                                        }, null, 8, ["numberValue", "model"])
                                      ]),
                                      _createElementVNode("td", _hoisted_16, [
                                        _createVNode(_component_ModelPropertyValue, {
                                          numberValue: (scenarioDifference.output == null ? 0 : scenarioDifference.output),
                                          model: _ctx.model
                                        }, null, 8, ["numberValue", "model"])
                                      ]),
                                      _createElementVNode("td", {
                                        style: {"white-space":"nowrap"},
                                        class: _normalizeClass(["text-right", { positiveResult: (scenarioDifference.outputDifference > 0), negativeResult: (scenarioDifference.outputDifference < 0) }])
                                      }, [
                                        _createTextVNode(_toDisplayString(scenarioDifference.outputDifference > 0 ? '+':'') + " ", 1),
                                        _createVNode(_component_ModelPropertyValue, {
                                          numberValue: scenarioDifference.outputDifference,
                                          model: _ctx.model
                                        }, null, 8, ["numberValue", "model"]),
                                        _createTextVNode(" (" + _toDisplayString(_ctx.$filters.percentage((scenarioDifference.outputDefault == 0 ? 1 : 1 / (scenarioDifference.outputDefault / scenarioDifference.outputDifference)))) + ") ", 1)
                                      ], 2)
                                    ]))
                                  }), 128))
                                ]),
                                _createElementVNode("tfoot", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", null, _toDisplayString(_ctx.$tc("message.total")), 1),
                                    _cache[2] || (_cache[2] = _createElementVNode("td", null, null, -1)),
                                    _cache[3] || (_cache[3] = _createElementVNode("td", null, null, -1)),
                                    _createElementVNode("td", _hoisted_17, [
                                      _createVNode(_component_ModelPropertyValue, {
                                        numberValue: _ctx.calculateTotelDifference(_ctx.scenarioDifferences.locations.slice(0,25)),
                                        model: _ctx.model
                                      }, null, 8, ["numberValue", "model"])
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          (_ctx.model.locationGroupsType == 1 && _ctx.scenarioDifferences.locationGroups.length > 1)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
                                _createElementVNode("h4", null, _toDisplayString(_ctx.$tc("message.locationsGroupsType" + _ctx.model.locationGroupsType + "Impact")), 1),
                                _createVNode(_component_v_table, { density: "compact" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$tc("message.locationGroupsType" + _ctx.model.locationGroupsType + "Name")), 1),
                                        _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$tc("message.before")), 1),
                                        _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$tc("message.after")), 1),
                                        _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$tc("message.difference")), 1)
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarioDifferences.locationGroups, (scenarioDifference) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: scenarioDifference.locationGroupName
                                        }, [
                                          _createElementVNode("td", null, _toDisplayString(scenarioDifference.locationGroupName == null ? _ctx.$tc("message.locationsGroupsType" + _ctx.model.locationGroupsType + "EmptyName") : scenarioDifference.locationGroupName), 1),
                                          _createElementVNode("td", _hoisted_23, [
                                            _createVNode(_component_ModelPropertyValue, {
                                              numberValue: (scenarioDifference.outputDefault == null ? 0 : scenarioDifference.outputDefault),
                                              model: _ctx.model
                                            }, null, 8, ["numberValue", "model"])
                                          ]),
                                          _createElementVNode("td", _hoisted_24, [
                                            _createVNode(_component_ModelPropertyValue, {
                                              numberValue: (scenarioDifference.output == null ? 0 : scenarioDifference.output),
                                              model: _ctx.model
                                            }, null, 8, ["numberValue", "model"])
                                          ]),
                                          _createElementVNode("td", {
                                            style: {"white-space":"nowrap"},
                                            class: _normalizeClass(["text-right", { positiveResult: (scenarioDifference.outputDifference > 0), negativeResult: (scenarioDifference.outputDifference < 0) }])
                                          }, [
                                            _createTextVNode(_toDisplayString(scenarioDifference.outputDifference > 0 ? '+':'') + " ", 1),
                                            _createVNode(_component_ModelPropertyValue, {
                                              numberValue: scenarioDifference.outputDifference,
                                              model: _ctx.model
                                            }, null, 8, ["numberValue", "model"]),
                                            _createTextVNode(" (" + _toDisplayString(_ctx.$filters.percentage((scenarioDifference.outputDefault == 0 ? 1 : 1 / (scenarioDifference.outputDefault / scenarioDifference.outputDifference)))) + ") ", 1)
                                          ], 2)
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.model.locationClustersType == 2 && _ctx.scenarioDifferences.locationClusters.length > 1)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
                                _createElementVNode("h4", null, _toDisplayString(_ctx.$tc("message.locationsClustersType" + _ctx.model.locationClustersType + "Impact")), 1),
                                _createVNode(_component_v_table, { density: "compact" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$tc("message.locationClustersType" + _ctx.model.locationClustersType + "Name")), 1),
                                        _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$tc("message.before")), 1),
                                        _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$tc("message.after")), 1),
                                        _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$tc("message.difference")), 1)
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarioDifferences.locationClusters, (scenarioDifference) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: scenarioDifference.locationClusterName
                                        }, [
                                          _createElementVNode("td", null, _toDisplayString(scenarioDifference.locationClusterName == null ? _ctx.$tc("message.locationsClustersType" + _ctx.model.locationClustersType + "EmptyName") : scenarioDifference.locationClusterName), 1),
                                          _createElementVNode("td", _hoisted_30, [
                                            _createVNode(_component_ModelPropertyValue, {
                                              numberValue: (scenarioDifference.outputDefault == null ? 0 : scenarioDifference.outputDefault),
                                              model: _ctx.model
                                            }, null, 8, ["numberValue", "model"])
                                          ]),
                                          _createElementVNode("td", _hoisted_31, [
                                            _createVNode(_component_ModelPropertyValue, {
                                              numberValue: (scenarioDifference.output == null ? 0 : scenarioDifference.output),
                                              model: _ctx.model
                                            }, null, 8, ["numberValue", "model"])
                                          ]),
                                          _createElementVNode("td", {
                                            style: {"white-space":"nowrap"},
                                            class: _normalizeClass(["text-right", { positiveResult: (scenarioDifference.outputDifference > 0), negativeResult: (scenarioDifference.outputDifference < 0) }])
                                          }, [
                                            _createTextVNode(_toDisplayString(scenarioDifference.outputDifference > 0 ? '+':'') + " ", 1),
                                            _createVNode(_component_ModelPropertyValue, {
                                              numberValue: scenarioDifference.outputDifference,
                                              model: _ctx.model
                                            }, null, 8, ["numberValue", "model"]),
                                            _createTextVNode(" (" + _toDisplayString(_ctx.$filters.percentage((scenarioDifference.outputDefault == 0 ? 1 : 1 / (scenarioDifference.outputDefault / scenarioDifference.outputDifference)))) + ") ", 1)
                                          ], 2)
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("section", _hoisted_32, [
                            _createVNode(_component_Mapbox, {
                              mapState: { zoom: 11 },
                              refresh: _ctx.refresh,
                              locations: _ctx.differentLocations,
                              location: _ctx.centerLocation,
                              model: _ctx.model,
                              style: {"width":"100%","height":"400px"},
                              onStartBusy: _ctx.startBusy,
                              onEndBusy: _ctx.endBusy
                            }, null, 8, ["refresh", "locations", "location", "model", "onStartBusy", "onEndBusy"])
                          ]),
                          _createElementVNode("section", null, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.disclaimer")), 1),
                            _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t("message.disclaimerContent")), 1)
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.model.scenarioReportFormat  && _ctx.scenarioDifferences)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          (_ctx.scenario)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_34, [
                                _createElementVNode("h3", null, _toDisplayString(_ctx.scenario.name), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.model.scenarioReportFormat).components, (component, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (component.name == 'mapImpact')
                                ? (_openBlock(), _createElementBlock("section", {
                                    key: index,
                                    style: {"pointer-events":"none","margin-top":"0.5em"}
                                  }, [
                                    _createVNode(_component_Mapbox, {
                                      mapState: { zoom: 11 },
                                      refresh: _ctx.refresh,
                                      locations: _ctx.differentLocations,
                                      location: _ctx.centerLocation,
                                      model: _ctx.model,
                                      style: {"width":"100%","height":"400px"},
                                      onStartBusy: _ctx.startBusy,
                                      onEndBusy: _ctx.endBusy
                                    }, null, 8, ["refresh", "locations", "location", "model", "onStartBusy", "onEndBusy"])
                                  ]))
                                : _createCommentVNode("", true),
                              (component.name == 'changedlocations')
                                ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.changedLocations")), 1),
                                    (_ctx.changedLocations.length> 0)
                                      ? (_openBlock(), _createBlock(_component_v_table, {
                                          key: 0,
                                          density: "compact"
                                        }, {
                                          default: _withCtx(() => [
                                            _cache[4] || (_cache[4] = _createElementVNode("thead", null, null, -1)),
                                            _createElementVNode("tbody", null, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.changedLocations, (location) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                  key: location.id
                                                }, [
                                                  _createElementVNode("td", null, _toDisplayString(location.name), 1),
                                                  _createElementVNode("td", _hoisted_35, [
                                                    (location.changeType == 1)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.$t("message.opening")), 1))
                                                      : _createCommentVNode("", true),
                                                    (location.changeType == 2)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t("message.closure")), 1))
                                                      : _createCommentVNode("", true),
                                                    (location.changeType == 3)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t("message.edited")), 1))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                              }), 128))
                                            ])
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (component.name == 'locationDifferences')
                                ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                    _createElementVNode("h4", null, _toDisplayString(_ctx.$tc("message.locationsType" + _ctx.model.locationsType + "Impact")), 1),
                                    _createVNode(_component_v_table, { density: "compact" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", null, [
                                            _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.$tc("message.locationsType" + _ctx.model.locationsType + "Name")), 1),
                                            _createElementVNode("th", _hoisted_40, _toDisplayString(_ctx.$tc("message.before")), 1),
                                            _createElementVNode("th", _hoisted_41, _toDisplayString(_ctx.$tc("message.after")), 1),
                                            _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.$tc("message.difference")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarioDifferences.locations.slice(0,25), (scenarioDifference) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: scenarioDifference.locationID
                                            }, [
                                              _createElementVNode("td", null, _toDisplayString(scenarioDifference.locationName), 1),
                                              _createElementVNode("td", _hoisted_43, [
                                                _createVNode(_component_ModelPropertyValue, {
                                                  numberValue: (scenarioDifference.outputDefault == null ? 0 : scenarioDifference.outputDefault),
                                                  model: _ctx.model
                                                }, null, 8, ["numberValue", "model"])
                                              ]),
                                              _createElementVNode("td", _hoisted_44, [
                                                _createVNode(_component_ModelPropertyValue, {
                                                  numberValue: (scenarioDifference.output == null ? 0 : scenarioDifference.output),
                                                  model: _ctx.model
                                                }, null, 8, ["numberValue", "model"])
                                              ]),
                                              _createElementVNode("td", {
                                                style: {"white-space":"nowrap"},
                                                class: _normalizeClass(["text-right", { positiveResult: (scenarioDifference.outputDifference > 0), negativeResult: (scenarioDifference.outputDifference < 0) }])
                                              }, [
                                                _createTextVNode(_toDisplayString(scenarioDifference.outputDifference > 0 ? '+':'') + " ", 1),
                                                _createVNode(_component_ModelPropertyValue, {
                                                  numberValue: scenarioDifference.outputDifference,
                                                  model: _ctx.model
                                                }, null, 8, ["numberValue", "model"]),
                                                _createTextVNode(" (" + _toDisplayString(_ctx.$filters.percentage((scenarioDifference.outputDefault == 0 ? 1 : 1 / (scenarioDifference.outputDefault / scenarioDifference.outputDifference)))) + ") ", 1)
                                              ], 2)
                                            ]))
                                          }), 128))
                                        ]),
                                        _createElementVNode("tfoot", null, [
                                          _createElementVNode("tr", null, [
                                            _createElementVNode("td", null, _toDisplayString(_ctx.$tc("message.total")), 1),
                                            _cache[5] || (_cache[5] = _createElementVNode("td", null, null, -1)),
                                            _cache[6] || (_cache[6] = _createElementVNode("td", null, null, -1)),
                                            _createElementVNode("td", _hoisted_45, [
                                              _createVNode(_component_ModelPropertyValue, {
                                                numberValue: _ctx.calculateTotelDifference(_ctx.scenarioDifferences.locations.slice(0,25)),
                                                model: _ctx.model
                                              }, null, 8, ["numberValue", "model"])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (component.name == 'locationGroupDifferences')
                                ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                    _createElementVNode("h4", null, _toDisplayString(_ctx.$tc("message.locationsGroupsType" + _ctx.model.locationGroupsType + "Impact")), 1),
                                    _createVNode(_component_v_table, { density: "compact" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", null, [
                                            _createElementVNode("th", _hoisted_46, _toDisplayString(_ctx.$tc("message.locationGroupsType" + _ctx.model.locationGroupsType + "Name")), 1),
                                            _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.$tc("message.before")), 1),
                                            _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.$tc("message.after")), 1),
                                            _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.$tc("message.difference")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarioDifferences.locationGroups, (scenarioDifference) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: scenarioDifference.locationGroupName
                                            }, [
                                              _createElementVNode("td", null, _toDisplayString(scenarioDifference.locationGroupName == null ? _ctx.$tc("message.locationsGroupsType" + _ctx.model.locationGroupsType + "EmptyName") : scenarioDifference.locationGroupName), 1),
                                              _createElementVNode("td", _hoisted_50, [
                                                _createVNode(_component_ModelPropertyValue, {
                                                  numberValue: (scenarioDifference.outputDefault == null ? 0 : scenarioDifference.outputDefault),
                                                  model: _ctx.model
                                                }, null, 8, ["numberValue", "model"])
                                              ]),
                                              _createElementVNode("td", _hoisted_51, [
                                                _createVNode(_component_ModelPropertyValue, {
                                                  numberValue: (scenarioDifference.output == null ? 0 : scenarioDifference.output),
                                                  model: _ctx.model
                                                }, null, 8, ["numberValue", "model"])
                                              ]),
                                              _createElementVNode("td", {
                                                style: {"white-space":"nowrap"},
                                                class: _normalizeClass(["text-right", { positiveResult: (scenarioDifference.outputDifference > 0), negativeResult: (scenarioDifference.outputDifference < 0) }])
                                              }, [
                                                _createTextVNode(_toDisplayString(scenarioDifference.outputDifference > 0 ? '+':'') + " ", 1),
                                                _createVNode(_component_ModelPropertyValue, {
                                                  numberValue: scenarioDifference.outputDifference,
                                                  model: _ctx.model
                                                }, null, 8, ["numberValue", "model"]),
                                                _createTextVNode(" (" + _toDisplayString(_ctx.$filters.percentage((scenarioDifference.outputDefault == 0 ? 1 : 1 / (scenarioDifference.outputDefault / scenarioDifference.outputDifference)))) + ") ", 1)
                                              ], 2)
                                            ]))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (component.name == 'locationClusterDifferences')
                                ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                    _createElementVNode("h4", null, _toDisplayString(_ctx.$tc("message.locationsClustersType" + _ctx.model.locationClustersType + "Impact")), 1),
                                    _createVNode(_component_v_table, { density: "compact" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", null, [
                                            _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.$tc("message.locationClustersType" + _ctx.model.locationClustersType + "Name")), 1),
                                            _createElementVNode("th", _hoisted_53, _toDisplayString(_ctx.$tc("message.before")), 1),
                                            _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.$tc("message.after")), 1),
                                            _createElementVNode("th", _hoisted_55, _toDisplayString(_ctx.$tc("message.difference")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarioDifferences.locationClusters, (scenarioDifference) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: scenarioDifference.locationClusterName
                                            }, [
                                              _createElementVNode("td", null, _toDisplayString(scenarioDifference.locationClusterName == null ? _ctx.$tc("message.locationsClustersType" + _ctx.model.locationClustersType + "EmptyName") : scenarioDifference.locationClusterName), 1),
                                              _createElementVNode("td", _hoisted_56, [
                                                _createVNode(_component_ModelPropertyValue, {
                                                  numberValue: (scenarioDifference.outputDefault == null ? 0 : scenarioDifference.outputDefault),
                                                  model: _ctx.model
                                                }, null, 8, ["numberValue", "model"])
                                              ]),
                                              _createElementVNode("td", _hoisted_57, [
                                                _createVNode(_component_ModelPropertyValue, {
                                                  numberValue: (scenarioDifference.output == null ? 0 : scenarioDifference.output),
                                                  model: _ctx.model
                                                }, null, 8, ["numberValue", "model"])
                                              ]),
                                              _createElementVNode("td", {
                                                style: {"white-space":"nowrap"},
                                                class: _normalizeClass(["text-right", { positiveResult: (scenarioDifference.outputDifference > 0), negativeResult: (scenarioDifference.outputDifference < 0) }])
                                              }, [
                                                _createTextVNode(_toDisplayString(scenarioDifference.outputDifference > 0 ? '+':'') + " ", 1),
                                                _createVNode(_component_ModelPropertyValue, {
                                                  numberValue: scenarioDifference.outputDifference,
                                                  model: _ctx.model
                                                }, null, 8, ["numberValue", "model"]),
                                                _createTextVNode(" (" + _toDisplayString(_ctx.$filters.percentage((scenarioDifference.outputDefault == 0 ? 1 : 1 / (scenarioDifference.outputDefault / scenarioDifference.outputDifference)))) + ") ", 1)
                                              ], 2)
                                            ]))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (component.name == 'disclaimer')
                                ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t("message.disclaimer")), 1),
                                    _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.$t("message.disclaimerContent")), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (component.name == 'textSection')
                                ? (_openBlock(), _createElementBlock("section", { key: index }, [
                                    _createElementVNode("h4", null, _toDisplayString(component.title), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.paragraphs, (paragraph, index) => {
                                      return (_openBlock(), _createElementBlock("p", {
                                        key: index,
                                        class: _normalizeClass(paragraph.class)
                                      }, _toDisplayString(paragraph.content), 3))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.model.name) + " (" + _toDisplayString(_ctx.model.id) + "/" + _toDisplayString(_ctx.scenario.id) + ") " + _toDisplayString(_ctx.environment == 'Production' ? '' : _ctx.environment), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "d-print-none" }, {
                  default: _withCtx(() => [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                    _createVNode(_component_v_btn, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.Window.print();}),
                      color: "primary",
                      variant: "text"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("message.print")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "text",
                      onClick: _ctx.close
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("message.close")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}